export const STORE_URL_ANDROID = 'https://redirect.appmetrica.yandex.com/serve/98949160845199629';
export const STORE_URL_ANDROID_DEEPLINK = 'https://redirect.appmetrica.yandex.com/serve/675343009067382139?id={id}';
export const STORE_URL_IOS =
    'https://3474082.redirect.appmetrica.yandex.com/start?appmetrica_tracking_id=98949160845199629';
export const STORE_URL_IOS_DEEPLINK =
    'https://3474082.redirect.appmetrica.yandex.com/j/{id}?appmetrica_tracking_id=675343009067382139';
export const IGNORE_DEVICE_IDS: Set<string> = new Set(['communications']);
export const STORE_URL_UNIVERSAL =
    'https://3474082.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=1110621214428172016&referrer=reattribution%3D1';
export const TELEMOST_LANDING_DOWNLOAD_APP_URL = 'https://360.yandex.ru/telemost/mobileapp/#download';
